import { EventEmitter, Injectable } from "@angular/core";
import { IsNotNull, IsNotNullOrEmpty, IsNull } from "@apply4u/shared/helpers/common/type-safe-helpers";

@Injectable({
    providedIn: 'root'
})
export class ConfirmationService {
    Message: string = "Are You Sure?";
    Action: string = "Confirm";
    Title: string = "Please Confirm...";
    ColseOnSuccess: boolean = true;
    ConfirmedEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
    SubscribedEvent: any;

    constructor() {
    }

    SetMessage(message: string, action: string = "Confirm", colseOnSuccess: boolean = true): ConfirmationService {
        this.Message = IsNotNullOrEmpty(message) ? message : "Are You Sure?";
        this.Action = IsNotNullOrEmpty(action) ? action : "Confirm";
        this.ColseOnSuccess = colseOnSuccess;

        return this;
    }

    SetTitle(title: string): ConfirmationService {
        this.Title = IsNotNullOrEmpty(title) ? title : "Please Confirm...";

        return this;
    }

    OpenConfirmationDialogue(callback: any): void {
        this.UnsubscribedEvent();

        if (IsNull(this.ConfirmedEvent) || this.ConfirmedEvent.closed == true) {
            this.ConfirmedEvent = new EventEmitter<boolean>();
        }

       const element = document.getElementById("btnConfirmationModalOpen");

       if(IsNotNull(element)){
        element.click();
       }

        this.SubscribedEvent = this.ConfirmedEvent.subscribe(m => { callback(m) });
    }

    OnSuccess(): void {
        this.ConfirmedEvent.emit(true);

        if (this.ColseOnSuccess) {
            this.CloseConfirmationDialogue();
        }

        this.ResetDialogue();
    }

    ResetDialogue() {
        this.SetMessage(null);
        this.SetTitle(null);
    }

    CloseConfirmationDialogue(): void {
        document.getElementById("btnConfirmationModalClose").click();
        this.UnsubscribedEvent();
    }

    private UnsubscribedEvent(): void {
        if (IsNotNull(this.SubscribedEvent) && this.SubscribedEvent.closed == false) {
            this.SubscribedEvent.unsubscribe();
        }
    }
}